<template>
  <div class="q-mt-md">
    <div v-if="voucherType.type === 'ticket'">
      <div class="text-h6 q-mb-sm">
        Matching Showings ({{ showings.loading ? '...' : filteredShowings.length }})
      </div>
      <div class="row">
        <q-inner-loading :showing="showings.loading" />
        <q-chip
          v-for="showing in filteredShowings.slice(0, 10)"
          :key="showing.id"
          clickable
          class="col-auto"
          size="md"
          :label="showing.movie.name + ' - ' + showing.time"
          style="max-width: 300px;"
          removable
          @remove="exclude('siteShowings', showing); excludeId('siteShowing', showing.id)"
        >
          <q-menu
            bordered
            side="right"
            overlay
          >
            <q-list>
              <q-item
                v-close-popup
                clickable
                @click.stop="include('siteMovies', showing.movie); includeId('siteMovie', showing.movie.id)"
              >
                <q-item-section avatar>
                  <q-icon name="filter_alt" />
                </q-item-section>
                <q-item-section>
                  Include Movie
                </q-item-section>
              </q-item>

              <q-item
                v-close-popup
                clickable
                @click.stop="include('showings', showing); includeId('showing', showing.id)"
              >
                <q-item-section avatar>
                  <q-icon name="filter_alt" />
                </q-item-section>
                <q-item-section>
                  Include Showing
                </q-item-section>
              </q-item>

              <q-separator />

              <q-item
                v-close-popup
                clickable
                @click.stop="exclude('movies', showing.movie); excludeId('movie', showing.movie.id)"
              >
                <q-item-section avatar>
                  <q-icon name="not_interested" />
                </q-item-section>
                <q-item-section>
                  Exclude Movie
                </q-item-section>
              </q-item>

              <q-item
                v-close-popup
                clickable
                @click.stop="exclude('showings', showing); excludeId('showing', showing.id)"
              >
                <q-item-section avatar>
                  <q-icon name="not_interested" />
                </q-item-section>
                <q-item-section>
                  Exclude Showing
                </q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </q-chip>
      </div>
    </div>
    <div v-if="voucherType.type === 'item'">
      <div class="text-h6 q-mb-sm">
        Matching Items ({{ filteredItems.length }})
      </div>
      <div class="row">
        <q-chip
          v-for="item in filteredItems.slice(0, 15)"
          :key="item.id"
          removable
          class="col-auto"
          size="md"
          :label="item.name"
          @remove="excludeId('item', item.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VoucherTypePreview',
  configuration: ['items'],
  props: {
    voucherType: {
      type: Object,
      required: true
    }
  },
  models: {
    showings: {
      movie: 'default',
      variables: {
        period: 'future',
        orderBy: 'time',
        limit: 200
      }
    }
  },
  computed: {
    filteredShowings () {
      return _.filter(this.showings.data, showing => this.voucherType.isShowingMatch(showing))
    },
    filteredItems () {
      return _.filter(this.activeItems, item => this.voucherType.isItemOrderItem({ item, itemVariation: item.itemVariations.data[0] }))
    },
    activeItems () {
      return _.filter(this.items.data, 'isUnarchived')
    }
  },
  methods: {
    include (type, model) {
      if (!_.some(this.voucherType[type].data, { id: model.id })) {
        this.voucherType[type].add(model)
      }

      this.voucherType['exclude' + _.startCase(type)] = false
    },
    exclude (type, model) {
      this.voucherType[type].add(model)
      this.voucherType['exclude' + _.startCase(type)] = true
    },
    includeId (type, id) {
      if (!_.include(this.voucherType[type + 'Ids'], id)) {
        this.voucherType[type + 'Ids'] = [id]
      }
      this.voucherType['exclude' + _.startCase(type) + 's'] = false
    },
    excludeId (type, id) {
      if (!this.voucherType['exclude' + _.startCase(type) + 's']) {
        this.voucherType[type + 'Ids'] = []
      }
      this.voucherType[type + 'Ids'].push(id)
      this.voucherType['exclude' + _.startCase(type) + 's'] = true
    }
  }
}

</script>
